import { createAsyncTypes } from 'utils/ActionCreator'

const NS = 'OnboardingWizard'

export const WIZARD_CREATE_TENANT = createAsyncTypes('CREATE_TENANT', NS)
export const WIZARD_FETCH_STATUS = createAsyncTypes('FETCH_STATUS', NS)
export const WIZARD_TRIGGER_SYNC = createAsyncTypes('TRIGGER_SYNC', NS)
export const WIZARD_GET_SETTINGS_OPTIONS = createAsyncTypes('GET_SETTINGS_OPTIONS', NS)
export const WIZARD_SAVE_SETTINGS = createAsyncTypes('SAVE_SETTINGS', NS)
export const WIZARD_ENABLE_DMARC = createAsyncTypes('ENABLE_DMARC', NS)
export const WIZARD_FETCH_GROUPS = createAsyncTypes('FETCH_GROUPS', NS)
export const WIZARD_FETCH_FAILED_MAILBOXES = createAsyncTypes('FETCH_FAILED_MAILBOXES', NS)
export const WIZARD_CREATE_GWS_ADMIN = createAsyncTypes('CREATE_GWS_ADMIN', NS)
export const WIZARD_ENABLE_GWS = createAsyncTypes('ENABLE_GWS', NS)

export const WIZARD_SET_STEP = `${NS}/SET_STEP`
export const WIZARD_SET_PROVIDER = `${NS}/SET_PROVIDER`
export const WIZARD_RESET = `${NS}/RESET`
export const WIZARD_RESUME_SESSION = `${NS}/RESUME_SESSION`

export const WIZARD_STEPS = [
  { id: 'company-details', label: 'Company Details' },
  { id: 'plans', label: 'Plans & Add-ons' },
  { id: 'integrate', label: 'Integrate' },
  { id: 'sync', label: 'Sync' },
  { id: 'settings', label: 'Settings' },
  { id: 'done', label: 'Launch' },
]
